<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Anggota
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.push('/keanggotaan/data-anggota/unverified')"
      >Kembali</Button>
    </div>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #214073 !important;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Data Anggota</router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-sertifikasi/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Data Sertifikasi</router-link>
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-rpl/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Data RPL</router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-pelatihan/'+this.$route.params.id_user"
          style="background-color: #486ba7;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Data Pelatihan</router-link>
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sanksi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >
          Sanksi
        </router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1 : index + indexed + 1}}</td>
            </template>
            <template #nama_pelatihan="{item}">
              <td class="py-2">{{ item.nama_pelatihan ? item.nama_pelatihan : '-' }}</td>
            </template>
            <template #status_pembayaran="{ item }">
              <td
                class="py-2 text-success font-weight-bold"
                v-if="item.status_pembayaran == 'settlement'"
              >
                Lunas
              </td>
              <td
                class="py-2 text-purple font-weight-bold"
                v-else-if="item.status_pembayaran == 'pending'"
              >
                Menunggu Pembayaran
              </td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'expired'"
              >
                Expired
              </td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'failure'"
              >
                Pembayaran Gagal
              </td>
              <td
                class="py-2 text-danger font-weight-bold"
                v-else-if="item.status_pembayaran == 0"
              >
                Belum Dibayar
              </td>
              <td
                class="py-2 text-danger font-weight-bold"
                v-else
              >
                Belum Lunas
              </td>
            </template>
            <template #status_pembatalan="{ item }">
                <td
                  class="py-2 text-success font-weight-bold"
                  v-if="item.status_pembatalan == 'Disetujui'"
                  
                >
                  Disetujui
                </td>
                <td
                  class="py-2 text-danger font-weight-bold"
                  v-else-if="item.status_pembatalan == 'Ditolak'"
                >
                  Ditolak
                </td>
                <td
                  class="py-2 text-warning font-weight-bold"
                  v-else-if="item.status_pembatalan == 'Pengajuan'"
                >
                  Pengajuan
                </td>
                <td class="py-2 text-secondary font-weight-bold" v-else>
                  Tidak Ada Pengajuan
                </td>
              </template>
          </CDataTable>          
        </CCol>
      </CRow>
      <!-- Modal Verif -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CRow>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nama File</th>
                  <th>File</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="row">1</td>
                  <td>dokumen 1</td>
                  <td>
                    <!-- <a
                      :href="'https://iapi-fo-user.birutekno.com/dokumen_persyaratan_workshop/'+val.file"
                      target="_blank"
                      v-if="val.file != ''"
                    >Lihat File</a>-->
                    <span class="text-primary">Lihat File</span>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-secondary text-center">Belum Upload</button>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-info">Verifikasi</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Verifikasi Dokumen Persyaratan Peserta Pelatihan</h6>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import RiwayatPesertaService from '@/services/keanggotaan/data-anggota/riwayat-peserta.service';
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_pelatihan",
    label: "Nama Pelatihan",
    sorter: true,
    filter: false,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false,
  },
  {
    key: "status_pembatalan",
    label: "Status Pembatalan",
    sorter: true,
    filter: false,
  },
];

export default {
  mixins: [AlertUtils, Pagination],
  name: "DataDokumen",
  data() {
    return {
      items: [],
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      modalVerif: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      RiwayatPesertaService.getRiwayatPesertaPelatihan(this.$route.params.id_user)
        .then((response) => {
          loader.hide();
          vm.items = response.data.data;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },
  },
};
</script>
